// @ts-check
import React from 'react';

import InfoIcon from '@liquidweb-dev/undercurrent/icons/lucide/Info';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

/**
 * @param {import('@liquidweb-dev/undercurrent/Stack').StackProps & {
 *   tier: import('modules/queries/support/usePhoneNumbers').SupportTier,
 * }} props
 */
const SupportTier = ({ tier, sx, ...rest }) => {
	return (
		<Stack direction="row" alignItems="center" spacing={150} {...rest}>
			<InfoIcon
				sx={({ size }) => ({
					width: size.xS,
					height: size.xS,
					flexShrink: 0,
				})}
			/>
			<Typography>
				Support Tier: {tier.display}. {tier.description}
			</Typography>
		</Stack>
	);
};

export default SupportTier;
